import { FC, useContext } from "react";
import cn from "classnames";
import TableCell from "./TableCell";
import { TableContext } from "./TableContext";

interface iProps {
    index: number;
    style: React.CSSProperties;
    data?: {
        styles: React.CSSProperties;
        Component?: FC;
        getExtraProps?: (index: number) => any;
    };
}

const TableRow: FC<iProps> = ({
    index,
    style,
    data,
}) => {
    const { config } = useContext(TableContext);

    const props = {
        className: cn(
            "TableNew__row",
            index % 2 ? "is-odd" : "is-even"
        ),
        style: {
            ...style,
            ...(data ? data.styles : {}),
        },
        'data-testid': `tableRow${index}`,
        children: <>
            {config.map((item, colIndex) => {
                const { Value, ...column } = item;
                return (
                    <TableCell
                        key={column.title}
                        index={index}
                        columnData={{ ...column, Value }}
                        props={{ head: false }}
                        testId={`tableCell${index}_${colIndex}`}
                    >
                        <Value index={index} />
                    </TableCell>
                );
            })}
        </>,
        ...data?.getExtraProps?.(index),
    }

    if (data?.Component) {
        return <data.Component {...props}/>;
    }

    return <div {...props} />;
};

export default TableRow;
